<template>
<svg viewBox="0 0 49 50" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-direction-alt`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_023796da6b__clip0_0:3287)"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.272 6.332a1.963 1.963 0 011.554 0l33.737 14.51c1.017.438 1.495 1.635 1.066 2.673a2.02 2.02 0 01-1.108 1.106l-12.377 4.99a2.021 2.021 0 00-1.126 1.147l-4.89 12.63c-.405 1.048-1.567 1.562-2.594 1.148-.5-.202-.9-.6-1.108-1.105L6.205 9.005c-.43-1.038.048-2.235 1.066-2.673zm4.45 5.629l10.47 25.347 4.07-10.511 10.3-4.153-24.84-10.683z"/></g><defs><clipPath id="svg_023796da6b__clip0_0:3287"><path transform="translate(0 .51)" d="M0 0h49v48.98H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconDirectionAlt',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
